import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_SCHEDULING_SETTING = createActionTypes('CREATE_SCHEDULING_SETTING');
export const FETCH_SCHEDULING_SETTING = createActionTypes('FETCH_SCHEDULING_SETTING');
export const GET_SCHEDULING_SETTING = createActionTypes('GET_SCHEDULING_SETTING');
export const UPDATE_SCHEDULING_SETTING = createActionTypes('UPDATE_SCHEDULING_SETTING');
export const DELETE_SCHEDULING_SETTING = createActionTypes('DELETE_SCHEDULING_SETTING');
